import React from 'react';
import { styles } from './ThumbnailImage.css';
import { useTrackingContext } from '../Tracking';
import { Link } from '../PlatformFunctionality';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';

export type ThumbnailImageProps = {
  image: React.ReactNode;
  title: string;
  href: string;
  isFullBleedImage?: boolean;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

export const ThumbnailImage = ({ image, title, href, isFullBleedImage = false, onClick }: ThumbnailImageProps) => {
  const { tracker } = useTrackingContext();

  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = event => {
    tracker.trackClick({ label: title, extraData: { moduleName: 'ThumbnailImage' } });
    onClick?.(event);
  };

  return (
    <Link className={styles.container} href={href} onClick={handleClick}>
      <div className={classNames(styles.imageContainer, styles.imageContainerRecipes({ isFullBleedImage }))}>
        {image ?? null}
      </div>
      <span className={styles.title}>{title ?? ''}</span>
    </Link>
  );
};
